module.exports = __webpack_public_path__ + "static/media/Timocco-Logo.727f4aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/timocco-resources/Timocco-Logo.png
// module id = 1700
// module chunks = 0